import { useParams } from 'react-router-dom';
import { Col, Row } from '../../../components/Grid';
import Button from '../../../components/Button';
import Title from '../../../components/Title';
import * as T from '../../../components/Typography';
import { CLIENT } from '../../../constants/nav-routes';

const SuccessFeedback = () => {
  const { id } = useParams();
  return (
    <>
      <Title boldSection="Thanks" lightSection="for your Feedback!" boldFirst />
      <Row>
        <Col w={[4, 4, 4]}>
          <T.P color="gray8" mb="4">
            This will help us to continue improving our digital resource to
            support your therapy further{' '}
          </T.P>
          <Button
            variant="primary"
            text="Return home"
            to={CLIENT.INDIVID_PROGRAMME.replace(':id', id)}
          />
        </Col>
      </Row>
    </>
  );
};

export default SuccessFeedback;
